import React from 'react';

/**
 * Accessible, clickable chart legend for toggling series/segment visibility.
 *
 * items: [{ key, label, color, dashed?, value? }]
 */
export default function ChartLegend({
  items,
  isVisible,
  onToggle,
  statusMessage = '',
  className = '',
}) {
  if (!items?.length) return null;

  return (
    <>
      <div
        className={`legend ${className}`.trim()}
        role="group"
        aria-label="Toggle chart series"
      >
        {items.map((item) => {
          const visible = isVisible(item.key);
          return (
            <button
              key={item.key}
              type="button"
              className={`legend-item${visible ? '' : ' legend-item--hidden'}`}
              aria-pressed={visible}
              aria-label={`${visible ? 'Hide' : 'Show'} ${item.label}`}
              onClick={() => onToggle(item.key)}
            >
              <span
                className={`legend-swatch${item.dashed ? ' line' : ''}`}
                style={{ background: item.color, color: item.color }}
                aria-hidden="true"
              />
              <span className="legend-label">{item.label}</span>
              {item.value != null && (
                <span className="legend-value">{item.value}</span>
              )}
            </button>
          );
        })}
      </div>
      <div className="sr-only" role="status" aria-live="polite">
        {statusMessage}
      </div>
    </>
  );
}
